export const BACKUP_PLAN_STORAGE_CREATED = "s0165";
export const BACKUP_PLAN_STORAGE_CREATE_ERROR = "e0165";
export const BACKUP_PLAN_STORAGE_UPDATED = "s0166";
export const BACKUP_PLAN_STORAGE_UPDATE_ERROR = "e0166";
export const BACKUP_PLAN_STORAGE_TURNED_ON = "s0167";
export const BACKUP_PLAN_STORAGE_TURN_ON_ERROR = "e0167";
export const BACKUP_PLAN_STORAGE_TURNED_OFF = "s0168";
export const BACKUP_PLAN_STORAGE_TURN_OFF_ERROR = "e0168";
export const BACKUP_PLAN_STORAGE_REMOVED = "s0169";
export const BACKUP_PLAN_STORAGE_REMOVE_ERROR = "e0169";

export const BACKUP_STORAGE_CREATED = "s0185";
export const BACKUP_STORAGE_CREATE_ERROR = "e0185";
export const BACKUP_STORAGE_UPDATED = "s0186";
export const BACKUP_STORAGE_UPDATE_ERROR = "e0186";
export const BACKUP_STORAGE_TURNED_ON = "s0187";
export const BACKUP_STORAGE_TURN_ON_ERROR = "e0187";
export const BACKUP_STORAGE_TURNED_OFF = "s0188";
export const BACKUP_STORAGE_TURN_OFF_ERROR = "e0188";
export const BACKUP_STORAGE_REMOVED = "s0189";
export const BACKUP_STORAGE_REMOVE_ERROR = "e0189";

export const backupPlanStorage = {
    [BACKUP_PLAN_STORAGE_CREATED]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backup.storage.plan.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.create"),
            entityType: $t("notification.contract.entity.backup_plan_storage"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_PLAN_STORAGE_UPDATED]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backup.storage.plan.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.update"),
            entityType: $t("notification.contract.entity.backup_plan_storage"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_PLAN_STORAGE_TURNED_ON]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backup.storage.plan.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOn"),
            entityType: $t("notification.contract.entity.backup_plan_storage"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_PLAN_STORAGE_TURNED_OFF]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backup.storage.plan.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOff"),
            entityType: $t("notification.contract.entity.backup_plan_storage"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_PLAN_STORAGE_CREATE_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backup.storage.plan.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.create"),
            entityType: $t("notification.contract.entity.backup_plan_storage"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_plan_storage")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    },
    [BACKUP_PLAN_STORAGE_UPDATE_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backup.storage.plan.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.update"),
            entityType: $t("notification.contract.entity.backup_plan_storage"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_plan_storage")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    },
    [BACKUP_PLAN_STORAGE_TURN_ON_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backup.storage.plan.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOn"),
            entityType: $t("notification.contract.entity.backup_plan_storage"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_plan_storage")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    },
    [BACKUP_PLAN_STORAGE_TURN_OFF_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backup.storage.plan.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOff"),
            entityType: $t("notification.contract.entity.backup_plan_storage"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_plan_storage")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    },
    [BACKUP_PLAN_STORAGE_REMOVED]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backup.storage.plan.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_plan_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.delete"),
            entityType: $t("notification.contract.entity.backup_plan_storage"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    }
};

export const backupStorage = {
    [BACKUP_STORAGE_CREATED]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backups.storage.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.create"),
            entityType: $t("notification.contract.entity.backup_storage"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_STORAGE_UPDATED]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backups.storage.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.update"),
            entityType: $t("notification.contract.entity.backup_storage"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_STORAGE_TURNED_ON]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backups.storage.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOn"),
            entityType: $t("notification.contract.entity.backup_storage"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_STORAGE_TURNED_OFF]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backups.storage.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOff"),
            entityType: $t("notification.contract.entity.backup_storage"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_STORAGE_REMOVED]: {
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.action",
        route: "contract.cabinet.backups.storage.index",
        langKeyNotificationAction: "notification.contract_entity.action",
        langKeyNotificationTitle: "notification.contract_entity.backup_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.delete"),
            entityType: $t("notification.contract.entity.backup_storage"),
            entityName: data.subjectName,
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        }),
        hash: (id) => `#${id}`
    },
    [BACKUP_STORAGE_CREATE_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backups.storage.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.create"),
            entityType: $t("notification.contract.entity.backup_storage"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_storage")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    },
    [BACKUP_STORAGE_UPDATE_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backups.storage.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.update"),
            entityType: $t("notification.contract.entity.backup_storage"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_storage")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    },
    [BACKUP_STORAGE_TURN_ON_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backups.storage.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOn"),
            entityType: $t("notification.contract.entity.backup_storage"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_storage")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    },
    [BACKUP_STORAGE_TURN_OFF_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backups.storage.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.turnOff"),
            entityType: $t("notification.contract.entity.backup_storage"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_storage")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    },
    [BACKUP_STORAGE_REMOVE_ERROR]: {
        isError: true,
        colorClass: "color_backup",
        icon: "/image/icons/reserved-icon.svg",
        langKeyHistory: "notification.contract_entity.error",
        route: "contract.cabinet.backups.storage.index",
        langKeyNotificationAction: "notification.contract_entity.error",
        langKeyNotificationTitle: "notification.contract_entity.backup_storage.title",
        routeParams: (data) => ({
            contractName: data.contractName
        }),
        langTextParams: (data, $t) => ({
            link: data.link,
            action: $t("notification.action.delete"),
            entityType: $t("notification.contract.entity.backup_storage"),
            entityName: data.subjectName,
            autoDeleteMessage: $t("notification.contract_entity.auto_delete", {
                entityType: $t("notification.contract.entity.backup_storage")
            }),
            user: data.initiatorName
        }),
        langTitleParams: (data) => ({
            name: data.subjectName
        })
    }
};


